import { zoneKey } from '../../duelEditor/core/field/zones';

/** **ドロー**（Issue #589）。分岐は無い。事実: `count`（枚数）/ `handBefore`（引く前の手札の枚数）。枚数が無ければ null */
export default Object.freeze({
  event: 'draw',
  label: 'ドロー',
  variants: Object.freeze([]),
  classify({ payload, board, boardBefore }) {
    const n = payload?.cards?.length ?? 0;
    if (!(n > 0)) return null;
    const key = zoneKey('hand', payload.player === 1 ? 1 : 0);
    const before = boardBefore?.count?.(key);
    const after = board?.count?.(key);
    const handBefore = Number.isFinite(before) ? before : (Number.isFinite(after) ? Math.max(0, after - n) : 0);
    return { ...payload, count: n, handBefore };
  },
});
